import { useState } from "react";
import { setAutoPublish } from "./api";

/**
 * Reglaget för direktpublicering (planens 7B).
 *
 * **Skolans beslut, inte vårt.** Skolan är personuppgiftsansvarig för sina
 * utskick, och texten här ska säga vad valet innebär — inte sälja in det.
 * Backenden skriver vem som ändrade och när, och en revisionsrad.
 */
export default function AutoPublish({ user, settings, onChange }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  if (!settings) return null;
  const on = settings.auto_publish;

  async function toggle() {
    // Att slå PÅ är ett beslut om vad eleverna ser utan att någon läst det.
    // Bekräftelsen skriver ut följden i stället för att fråga "är du säker?".
    if (!on && !window.confirm(
      "Slå på direktpublicering?\n\n" +
      "Utskick som klarar spärrarna blir sökbara för eleverna direkt, utan " +
      "att någon hos er läser dem först.\n\n" +
      "Det förutsätter att Aerro-adressen bara ligger på utskick som går till " +
      "hela skolan. Ni kan ta bort ett publicerat utskick i efterhand.")) return;

    setBusy(true);
    setError(null);
    try {
      await setAutoPublish(user, !on);
      await onChange();
    } catch (caught) {
      setError(caught.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="card">
      <h2>Direktpublicering</h2>
      <p className={on ? "notice" : "hint"}>
        {on
          ? "PÅ — utskick som klarar spärrarna publiceras utan granskning."
          : "AV — varje utskick granskas av er innan eleverna kan få svar ur det."}
      </p>
      {on && settings.auto_publish_by && (
        <p className="hint">
          Påslaget av {settings.auto_publish_by}
          {settings.auto_publish_at &&
            ` ${new Date(settings.auto_publish_at).toLocaleDateString("sv-SE")}`}.
        </p>
      )}
      <p className="hint">
        Går alltid till granskning ändå: personnummer, klassbeteckningar, ord om
        elevhälsa, ord som visar att utskicket gick till en del av skolan, och
        utskick med bilaga.
      </p>
      <button className={on ? "danger" : "secondary"} disabled={busy} onClick={toggle}>
        {busy ? "Sparar…" : on ? "Stäng av" : "Slå på"}
      </button>
      {error && <p className="error">{error}</p>}
    </section>
  );
}
